import React from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { Loader } from 'core/components';
import { MasterLayoutTemplate } from 'themes/layouts';

@inject(i => ({
	initialized: i.rootStore.appStore.initialized,
}))
class MasterLayout extends React.Component {
	render() {
		const { initialized } = this.props;
		if (!initialized) return <Loader />;
		return (
			<React.Fragment>
				<MasterLayoutTemplate {...this.props} />
			</React.Fragment>
		);
	}
}

MasterLayout.propTypes = {
	render: PropTypes.func,
};

export default MasterLayout;



// WEBPACK FOOTER //
// ./src/core/layouts/MasterLayout.jsx